import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App';
import { initTelegram } from './telegram';
import { initColorScheme } from './lib/color-scheme';
import './styles.css';

// SDK инициализируем ДО первого рендера: initDataRaw нужен уже первому запросу.
initTelegram();
// Светлую/тёмную палитру выбираем до первого кадра, иначе будет вспышка.
initColorScheme();

const container = document.getElementById('root');
if (!container) throw new Error('#root not found');

createRoot(container).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
